import React from "react";
import { Translate } from "react-localize-redux";
import './styles.scss';

const privacyText = [
  <Translate id="Privacyline1" />,
  <Translate id="Privacyline2" />,
  <Translate id="Privacyline3" />,
  <Translate id="Privacyline4" />,
  <Translate id="Privacyline5" />,
  <Translate id="Privacyline6" />,
  <Translate id="Privacyline7" />,
  <Translate id="Privacyline8" />,
  <Translate id="Privacyline9" />,
  <Translate id="Privacyline10" />,
  <Translate id="Privacyline11" />,
];

const PrivacyInfo = props => {
  return (
    <div id="root-privacy-container" className="col-lg-12 text-center">
      <br/>
      <h3 className="modal-title">
        <Translate id="PrivacyText" />
      </h3>
      <br/>
      <div className="text-left">
        <h5 className="PrivacyInfo__terms">
          <Translate id="TermsandConditions" />
        </h5>
        {privacyText.map((item, index) =>
          <div className="row privacy-info-row">
            <div className="col-lg-1 PrivacyInfo__index_row">{index + 1}</div>
            <div className="col-lg-11 PrivacyInfo__text_row">{item}</div>
          </div>
        )}
      </div>
      <br/>
      {props.showClose && <div className="row">
        <div className="col-lg-12 text-center">
          <button
            className="btn btn-primary edit-profile-header-cancel-btn"
            onClick={props.toggleModal}>
            <Translate id="Close" />
          </button>
        </div>
      </div>
      }
    </div>
  );
};

export default PrivacyInfo;


// WEBPACK FOOTER //
// ./src/components/PrivacyInfo/PrivacyInfo.jsx